<div class="page-wrapper">
  <!-- ============================================================== -->
  <!-- Container fluid  -->
  <!-- ============================================================== -->
  <div class="container-fluid">
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">
          Tipos de operaciones del canal: {{ canal }}
        </h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li
            class="breadcrumb-item active"
            routerLink="/dashboard/inicio"
            style="cursor: pointer"
          >
            Inicio
          </li>
          <li
            class="breadcrumb-item active"
            routerLink="/dashboard/canales-y-operaciones"
            style="cursor: pointer"
          >
            Gestion de canales y Tipos de operaciones
          </li>
          <li class="breadcrumb-item">Tipos de operaciones</li>
        </ol>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Start Page Content -->
    <!-- ============================================================== -->
    <div class="row justify-content-center align-items-center">
      <div class="col-12 col-md-12 col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <!-- MAT TABLE -->
              <div class="content-table">
                <table
                  mat-table
                  #dataTable
                  [dataSource]="dataSource"
                  matSort
                  style="width: 100%; --min-width: 600px"
                  class="table-striped"
                >
                  <!-- NOMBRE -->
                  <ng-container matColumnDef="nombre">
                    <th
                      class="header-options"
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                    >
                      Tipos de operación
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.nombre }}
                    </td>
                  </ng-container>
                  <!-- ESTATUS -->
                  <ng-container matColumnDef="estatus">
                    <th
                      class="header-options"
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                    >
                      Estatus
                    </th>
                    <td mat-cell *matCellDef="let element">Activo</td>
                  </ng-container>
                  <!-- OPCIONES -->
                  <ng-container matColumnDef="opciones">
                    <th
                      class="header-options"
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                    ></th>
                    <td mat-cell *matCellDef="let element" class="options">
                      <button
                        *ngIf="actualizarTipos"
                        (click)="editar(element)"
                        class="btn btn-warning waves-effect mr-2"
                      >
                        <i class="mdi mdi-pencil"></i>
                      </button>
                      <button
                        *ngIf="eliminarTipos"
                        (click)="eliminar(element.id_tipos_operaciones)"
                        class="btn btn-danger waves-effect"
                      >
                        <i class="mdi mdi-delete"></i>
                      </button>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="select-options">
                    <th
                      mat-header-cell
                      class="th-options"
                      colspan="3"
                      *matHeaderCellDef
                    >
                      <div class="search">
                        <i class="fas fa-search"></i>
                        <input
                          type="text"
                          [(ngModel)]="buscar"
                          (keyup)="search()"
                          matInput
                          placeholder="Filtrar..."
                        />
                      </div>
                      <div class="content-options" *ngIf="crearTipos">
                        <i
                          class="fas fa-plus"
                          matTooltip="Agregar tipo operación"
                          (click)="crear()"
                        ></i>
                      </div>
                    </th>
                  </ng-container>

                  <tr
                    mat-header-row
                    class="tr-options"
                    *matHeaderRowDef="['select-options']"
                  ></tr>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                  ></tr>
                </table>
              </div>
              <mat-paginator
                [pageSizeOptions]="[5, 10, 25, 50, 100]"
                [pageSize]="5"
                [showFirstLastButtons]
              ></mat-paginator>
            </div>
          </div>
        </div>
      </div>

      <!-- ============================================================== -->
      <!-- End PAge Content -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Container fluid  -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
  </div>
</div>
